/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/news/r/'>.
 * /r/-пагинация (§3.2)
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import News from '@routes/News';
import { getQueryClient } from '../../../providers/query';
import {
  newsInfiniteQueryOptions,
  resolveNewsSetLimit
} from '@queries/index';
import { getURLProps } from '@utils/setPagesUrl';
import { isContentNotFoundError } from '../../../api/contentNotFound';
import { assertValidListUrl } from '../../../ssrListParams';

export const Route = createFileRoute('/news/r/$')({
  /**
   * ЭТАП 2 — честный 404 несуществующей страницы списка (/news/r/page/99999):
   * бэк (findNewsAll) кидает CONTENT_NOT_FOUND через checkPageHasItems (и
   * checkPageNumber для page < 1) -> notFound() -> HTTP 404 + контент /404
   * без редиректа. ensureInfiniteQueryData дедуплицируется с root-префетчем
   * (тот же ключ {setLimit} и стартовая страница) — лишнего запроса нет.
   * page 1 не проверяем (пустой раздел — норма, как на бэке); клиентскую
   * навигацию не блокируем.
   */
  loader: async ({ location }) => {
    if (typeof window !== 'undefined') {
      return;
    }
    // Хвост /r/ обязан быть каноническим: чужие ключи, битые значения
    // и /r/page/1 — честный 404, см. src/ssrListParams.ts
    assertValidListUrl('news', location.pathname);
    const urlProps = getURLProps({ pathname: location.pathname });
    const page = parseInt(`${urlProps.page}`, 10);
    if (Number.isNaN(page) || page === 1) {
      return;
    }
    const queryClient = getQueryClient();
    const options = newsInfiniteQueryOptions(
      { setLimit: resolveNewsSetLimit(urlProps.last) },
      page
    );
    // Префетч успел упасть раньше — ошибка уже в кэше, без второго запроса
    const settled = queryClient.getQueryState(options.queryKey);
    if (settled?.error) {
      if (isContentNotFoundError(settled.error)) {
        throw notFound();
      }
      return;
    }
    try {
      await queryClient.ensureInfiniteQueryData(options);
    } catch (error) {
      if (isContentNotFoundError(error)) {
        throw notFound();
      }
    }
  },
  component: () => <CacheDataRoute component={News} path='/news/r/' />
});
